export default __webpack_public_path__ + "static/media/Provider_education.f6e5265e.svg";